import { render, staticRenderFns } from "./insertionModal.vue?vue&type=template&id=00d6dc2c&"
import script from "./insertionModal.vue?vue&type=script&lang=ts&"
export * from "./insertionModal.vue?vue&type=script&lang=ts&"
import style0 from "./insertionModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports